/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink } from "react-router-dom";
import SingleOpportunity from "./SingleOpportunity";

export function OpportunitiesWidget({ className, opportunities }) {
  return (
    <>
      <div className={className}>
        <div className="card-body mh-100">
          <div className="d-flex">
            <div className="d-flex flex-column w-100">
              <NavLink to="/opportunities">
                <h3 className="card-title font-weight-bolder text-dark text-hover-primary">
                  Latest Opportunities
                </h3>
              </NavLink>

              <div className="mt-1 overflow-auto h-sm-475px">
                {opportunities.items.map((item, index) => (
                  <SingleOpportunity item={item} index={index} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
